export default __webpack_public_path__ + "ae83439779b357ef096e93da6d338fd7.png";